import React, { useState, useEffect } from "react";
import NumberButton from "./components/NumberButton";
import Display from "./components/Display";
import OperationButton from "./components/OperationButton";
import ClearButton from "./components/ClearButton";
import EvaluateButton from "./components/EvaluateButton";
import BackspaceButton from "./components/BackspaceButton";
import DecimalButton from "./components/DecimalButton";

function App() {
  const [displayState, setDisplayState] = useState("");

  function exceedFifteen() {
    if (displayState.length === 15) {
      alert("Don't exceed 15 digits")
      setDisplayState("")
    }
  }
  exceedFifteen()

  /*Infinity should be shown on the display when it occurs. 
  So this function has to be called before a users button click may be executed. 
  The only button that doesn't need to check if Infinity is the C button.*/
  function wipeIfInfinity() {
    if (displayState === "Infinity") {
      setDisplayState("");
    }
  }

  function clickNumber(num) {
    wipeIfInfinity();
    setDisplayState((prevState) => prevState + num);
  }

  function clearDisplay() {
    setDisplayState("");
  }

  function deleteLastInput() {
    wipeIfInfinity();
    setDisplayState((prevState) => prevState.slice(0, prevState.length - 1));
  }

  function addOperator(operation) {
    wipeIfInfinity();
    const lastEntry = Array.from(displayState).pop();
    if (
      lastEntry !== "+" &&
      lastEntry !== "-" &&
      lastEntry !== "*" &&
      lastEntry !== "/"
    ) {
      setDisplayState((prevState) => prevState + operation);
    }
  }

  //Also checks if the current number already contains a decimal point. If that is the case it does not allow another decimal point.
  function addDecimal() {
    wipeIfInfinity();
    const numbers = displayState.split(/[\+\-\*\/]/); // Split by operators
    const currentNumber = numbers.pop();
    if (!currentNumber.includes(".")) {
      setDisplayState((prevState) => prevState + ".");
    }
  }

  function evaluate() {
    wipeIfInfinity();
    const evaluated = String(eval(displayState));
    const lastEntry = Array.from(evaluated).pop();
    if (lastEntry !== ".") {
      setDisplayState(evaluated);
    }
  }

  return (
      <header className="App-header">
        <div className="d-flex justify-content-center">
          <div className="calculator card">
          <Display displayState={displayState} />
        <div className="calculator-keys">
        <ClearButton onClick={clearDisplay} />
          <BackspaceButton onClick={deleteLastInput} />
          <EvaluateButton onClick={evaluate} />
          <OperationButton operation={"*"} onClick={addOperator} />
        
        
          <NumberButton num={7} onClick={clickNumber} />
          <NumberButton num={8} onClick={clickNumber} />
          <NumberButton num={9} onClick={clickNumber} />
          <OperationButton operation={"-"} onClick={addOperator} />
        
        
        
          <NumberButton num={4} onClick={clickNumber} />
          <NumberButton num={5} onClick={clickNumber} />
          <NumberButton num={6} onClick={clickNumber} />
          <OperationButton operation={"+"} onClick={addOperator} />
        
        
        
          <NumberButton num={1} onClick={clickNumber} />
          <NumberButton num={2} onClick={clickNumber} />
          <NumberButton num={3} onClick={clickNumber} />
          <OperationButton operation={"/"} onClick={addOperator} />
          <button className="invisible"/>
          <NumberButton num={0} onClick={clickNumber} />
          <DecimalButton onClick={addDecimal} />
        
        </div>
        </div>
        </div>
      </header>
  );
}

export default App;
